import { IIngredient, Ingredient } from './IIngredient'
import { IPackaging, IPackagingParts, Packaging } from './IPackaging'
import { Batch, IBatch } from './IPremix'
import { IProduct, Product } from './IProduct'

export interface IStockCard {
  [key: string]:
  | string
  | number
  | null
  | boolean
  | IStockCardPackaging[]
  | IStockCardIngredients[]
  | IStockCardProducts[]
  | IStockCardBatch[]
  | undefined
  dynamicLatestStock?: number | string | null
  stockCardDisplayId: string
  stockCardId: number | null
  quantity: number | string | null
  latestStock: number | string | null
  confirmedQuantity: number | string | null
  expectedQuantity: number | string | null
  batchNumber: string
  expiryDate: string
  inOutDirection: string
  outgoingDestination: string
  premixId: string
  productionId: number | null
  productId: string
  salesOrderId: number | null
  invoiceId: number | null
  ingredientId: string
  packagingId: string
  purchaseOrderNumber: string
  rndRequestNumber: string
  type: string
  fillingAmount: number | null
  fillingUnit: string
  orderId: number | null
  salesOrderDisplayId: string
  salesOrderCreatedAt: string
  invoiceDisplayId: string
  invoiceCreatedAt: string
  packagingName: string
  pictureUrl: string | null
  notes: string
  confirmedBy: string
  confirmedAt: string
  isConfirmed: boolean
  createdAt: string
  createdBy: string
  stockCardPackaging: IStockCardPackaging[]
  stockCardIngredients: IStockCardIngredients[]
  stockCardProducts: IStockCardProducts[]
  stockCardBatches: IStockCardBatch[]
}

export class StockCard {
  [key: string]:
  | string
  | number
  | null
  | boolean
  | IStockCardPackaging[]
  | IStockCardIngredients[]
  | IStockCardProducts[]
  | IStockCardBatch[]
  | undefined
  dynamicLatestStock?: number | string | null
  stockCardDisplayId: string
  stockCardId: number | null
  quantity: number | string | null
  latestStock: number | string | null
  confirmedQuantity: number | string | null
  expectedQuantity: number | string | null
  batchNumber: string
  expiryDate: string
  inOutDirection: string
  outgoingDestination: string
  premixId: string
  productionId: number | null
  productId: string
  salesOrderId: number | null
  invoiceId: number | null
  ingredientId: string
  packagingId: string
  purchaseOrderNumber: string
  rndRequestNumber: string
  type: string
  fillingAmount: number | null
  fillingUnit: string
  orderId: number | null
  salesOrderDisplayId: string
  salesOrderCreatedAt: string
  invoiceDisplayId: string
  invoiceCreatedAt: string
  packagingName: string
  pictureUrl: string | null
  notes: string
  confirmedBy: string
  confirmedAt: string
  isConfirmed: boolean
  createdAt: string
  createdBy: string
  stockCardPackaging: IStockCardPackaging[]
  stockCardIngredients: IStockCardIngredients[]
  stockCardProducts: IStockCardProducts[]
  stockCardBatches: IStockCardBatch[]

  constructor({
    stockCardDisplayId,
    premixId,
    productId,
    ingredientId,
    packagingId,
    productionId,
    stockCardId,
    expiryDate,
    quantity,
    latestStock,
    confirmedQuantity,
    expectedQuantity,
    batchNumber,
    inOutDirection,
    outgoingDestination,
    purchaseOrderNumber,
    rndRequestNumber,
    type,
    fillingAmount,
    fillingUnit,
    salesOrderId,
    invoiceId,
    notes,
    orderId,
    salesOrderDisplayId,
    salesOrderCreatedAt,
    invoiceDisplayId,
    invoiceCreatedAt,
    packagingName,
    pictureUrl,
    confirmedBy,
    confirmedAt,
    isConfirmed,
    createdAt,
    createdBy,
    stockCardPackaging,
    stockCardIngredients,
    stockCardProducts,
    stockCardBatches,
    dynamicLatestStock,
  }: Partial<IStockCard> = {}) {
    this.stockCardDisplayId = stockCardDisplayId || ''
    this.premixId = premixId || ''
    this.productId = productId || ''
    this.salesOrderId = salesOrderId ?? null
    this.invoiceId = invoiceId ?? null
    this.ingredientId = ingredientId || ''
    this.packagingId = packagingId || ''
    this.productionId = productionId ?? null
    this.type = type || ''
    this.expiryDate = expiryDate || ''
    this.latestStock = latestStock || null
    this.outgoingDestination = outgoingDestination || ''
    this.inOutDirection = inOutDirection || ''
    this.batchNumber = batchNumber || ''
    this.fillingAmount = fillingAmount || null
    this.fillingUnit = fillingUnit || ''
    this.isConfirmed = isConfirmed ?? false
    this.quantity = quantity || null
    this.confirmedQuantity = confirmedQuantity || null
    this.expectedQuantity = expectedQuantity || null
    this.latestStock = latestStock || null
    this.stockCardId = stockCardId ?? null
    this.confirmedBy = confirmedBy || ''
    this.confirmedAt = confirmedAt || ''
    this.notes = notes || ''
    this.orderId = orderId || null
    this.salesOrderDisplayId = salesOrderDisplayId || ''
    this.salesOrderCreatedAt = salesOrderCreatedAt || ''
    this.invoiceDisplayId = invoiceDisplayId || ''
    this.invoiceCreatedAt = invoiceCreatedAt || ''
    this.packagingName = packagingName || ''
    this.pictureUrl = pictureUrl ?? null
    this.createdAt = createdAt || ''
    this.createdBy = createdBy || ''
    this.stockCardPackaging = stockCardPackaging ?? []
    this.stockCardIngredients = stockCardIngredients ?? []
    this.stockCardProducts = stockCardProducts ?? []
    this.stockCardBatches = stockCardBatches ?? []
    this.dynamicLatestStock = dynamicLatestStock ?? null
    this.purchaseOrderNumber = purchaseOrderNumber || ''
    this.rndRequestNumber = rndRequestNumber || ''
  }
}

export interface IStockCardIngredients {
  stockCardIngredientId: number | null
  stockCardId: number | null
  ingredient: IIngredient | null
  ingredientId: string
  ingredientName: string
  quantity: number | string | null
  confirmedQuantity: number | string | null
  createdAt: string
  confirmedAt: string
  createdBy: string
  confirmedBy: string
  latestStock: number | string | null
  dynamicLatestStock?: number | string | null
}
export class StockCardIngredients {
  stockCardIngredientId: number | null
  stockCardId: number | null
  ingredient: IIngredient | null
  ingredientId: string
  ingredientName: string
  quantity: number | string | null
  confirmedQuantity: number | string | null
  createdAt: string
  confirmedAt: string
  createdBy: string
  confirmedBy: string
  latestStock: number | string | null
  dynamicLatestStock?: number | string | null

  constructor({
    stockCardIngredientId,
    stockCardId,
    ingredient,
    ingredientId,
    ingredientName,
    quantity,
    confirmedQuantity,
    createdAt,
    confirmedAt,
    createdBy,
    confirmedBy,
    latestStock,
    dynamicLatestStock,
  }: Partial<IStockCardIngredients> = {}) {
    this.stockCardIngredientId = stockCardIngredientId ?? null
    this.stockCardId = stockCardId ?? null
    this.ingredient = ingredient ?? new Ingredient(arguments[0])
    this.ingredientId = ingredientId || ''
    this.ingredientName = ingredientName || ''
    this.quantity = quantity ?? null
    this.confirmedQuantity = confirmedQuantity ?? null
    this.createdAt = createdAt || ''
    this.confirmedAt = confirmedAt || ''
    this.createdBy = createdBy || ''
    this.confirmedBy = confirmedBy || ''
    this.latestStock = latestStock ?? null
    this.dynamicLatestStock = dynamicLatestStock ?? null
  }
}

export interface IStockCardPackaging {
  [key: string]: any
  stockCardPackagingId: number | null
  stockCardId: number | null
  packaging: IPackaging | null
  packagingId: string
  packagingPartId: string
  partName: string
  quantity: number | string | null
  confirmedQuantity: number | string | null
  latestStock: number | string | null
  dynamicLatestStock?: number | string | null
  expectedQuantity: number | string | null
  createdAt: string
  confirmedAt: string
  createdBy: string
  confirmedBy: string
  packagingPart: IPackagingParts | null
}
export class StockCardPackaging {
  [key: string]: any
  stockCardPackagingId: number | null
  stockCardId: number | null
  packaging: IPackaging | null
  packagingId: string
  packagingPartId: string
  partName: string
  quantity: number | string | null
  confirmedQuantity: number | string | null
  latestStock: number | string | null
  dynamicLatestStock?: number | string | null
  expectedQuantity: number | string | null
  createdAt: string
  confirmedAt: string
  createdBy: string
  confirmedBy: string
  packagingPart: IPackagingParts | null

  constructor({
    stockCardPackagingId,
    stockCardId,
    packaging,
    packagingId,
    packagingPartId,
    partName,
    quantity,
    confirmedQuantity,
    latestStock,
    dynamicLatestStock,
    expectedQuantity,
    createdAt,
    confirmedAt,
    createdBy,
    confirmedBy,
    packagingPart,
  }: Partial<IStockCardPackaging> = {}) {
    this.stockCardPackagingId = stockCardPackagingId ?? null
    this.stockCardId = stockCardId ?? null
    this.packaging = packaging ?? new Packaging(arguments[0])
    this.packagingId = packagingId || ''
    this.packagingPartId = packagingPartId ?? ''
    this.partName = partName ?? ''
    this.quantity = quantity ?? null
    this.confirmedQuantity = confirmedQuantity ?? null
    this.latestStock = latestStock ?? null
    this.dynamicLatestStock = dynamicLatestStock ?? null
    this.expectedQuantity = expectedQuantity ?? null
    this.createdAt = createdAt || ''
    this.confirmedAt = confirmedAt || ''
    this.createdBy = createdBy || ''
    this.confirmedBy = confirmedBy || ''
    this.packagingPart = packagingPart ?? null
  }
}

export interface IStockCardProducts {
  [key: string]: any
  stockCardProductId: number | null
  stockCardId: number | null
  product: IProduct | null
  productId: number | null
  batchNumber: string
  premixId: string
  packagingId: string
  fillingAmount: string
  fillingUnit: string
  quantity: number | string | null
  confirmedQuantity: number | string | null
  createdAt: string
  confirmedAt: string
  createdBy: string
  confirmedBy: string
  latestStock: number | string | null
  dynamicLatestStock?: number | string | null
  expectedQuantity: number | string | null
  labelId: string | null
}
export class StockCardProducts {
  [key: string]: any
  stockCardProductId: number | null
  stockCardId: number | null
  product: IProduct | null
  productId: number | null
  batchNumber: string
  premixId: string
  packagingId: string
  fillingAmount: string
  fillingUnit: string
  quantity: number | string | null
  confirmedQuantity: number | string | null
  createdAt: string
  confirmedAt: string
  createdBy: string
  confirmedBy: string
  latestStock: number | string | null
  dynamicLatestStock?: number | string | null
  expectedQuantity: number | string | null
  labelId: string | null

  constructor({
    stockCardProductId,
    stockCardId,
    product,
    productId,
    batchNumber,
    premixId,
    packagingId,
    fillingAmount,
    fillingUnit,
    quantity,
    confirmedQuantity,
    createdAt,
    confirmedAt,
    createdBy,
    confirmedBy,
    latestStock,
    dynamicLatestStock,
    expectedQuantity,
    labelId,
  }: Partial<IStockCardProducts> = {}) {
    this.stockCardProductId = stockCardProductId ?? null
    this.stockCardId = stockCardId ?? null
    this.product = product ?? new Product(arguments[0])
    this.productId = productId || null
    this.batchNumber = batchNumber ?? ''
    this.premixId = premixId ?? ''
    this.packagingId = packagingId ?? ''
    this.fillingAmount = fillingAmount ?? ''
    this.fillingUnit = fillingUnit ?? ''
    this.quantity = quantity ?? null
    this.confirmedQuantity = confirmedQuantity ?? null
    this.createdAt = createdAt || ''
    this.confirmedAt = confirmedAt || ''
    this.createdBy = createdBy || ''
    this.confirmedBy = confirmedBy || ''
    this.latestStock = latestStock ?? null
    this.dynamicLatestStock = dynamicLatestStock ?? null
    this.expectedQuantity = expectedQuantity ?? null
    this.labelId = labelId ?? null
  }
}

export interface IStockCardBatch {
  stockCardBatchId: number | null
  stockCardId: number
  batch: IBatch | null
  batchNumber: string
  quantity: number | string | null
  confirmedQuantity: number | string | null
  createdAt: string
  confirmedAt: string
  createdBy: string
  confirmedBy: string
  latestStock: number | string | null
  dynamicLatestStock?: number | string | null
}
export class StockCardBatch {
  stockCardBatchId: number | null
  stockCardId: number
  batch: IBatch | null
  batchNumber: string
  quantity: number | string | null
  confirmedQuantity: number | string | null
  createdAt: string
  confirmedAt: string
  createdBy: string
  confirmedBy: string
  latestStock: number | string | null
  dynamicLatestStock?: number | string | null

  constructor({
    stockCardBatchId,
    stockCardId,
    batch,
    batchNumber,
    quantity,
    confirmedQuantity,
    createdAt,
    confirmedAt,
    createdBy,
    confirmedBy,
    latestStock,
    dynamicLatestStock,
  }: Partial<IStockCardBatch> = {}) {
    this.stockCardBatchId = stockCardBatchId ?? null
    this.batch = batch ?? new Batch(arguments[0])
    this.stockCardId = stockCardId ?? 0
    this.batchNumber = batchNumber || ''
    this.quantity = quantity ?? null
    this.confirmedQuantity = confirmedQuantity ?? null
    this.createdAt = createdAt || ''
    this.confirmedAt = confirmedAt || ''
    this.createdBy = createdBy || ''
    this.confirmedBy = confirmedBy || ''
    this.latestStock = latestStock ?? null
    this.dynamicLatestStock = dynamicLatestStock ?? null
  }
}
